import React, { useCallback, useMemo } from "react";
import CommonGridTable from "app/components/Table/CommonGridTable";
import NotificationRow from "app/containers/Features/containers/TeamSettings/container/Notification/NotificationRow";
import { headers } from "app/containers/Features/containers/TeamSettings/container/Notification/data";
import { NotificationMethodEnum } from "app/containers/Features/containers/TeamSettings/container/Notification/type";
import { useDispatch, useSelector } from "react-redux";
import {
  selectIsLoading,
  selectNotificationSettings,
} from "app/containers/Features/containers/TeamSettings/container/Notification/redux/selector";
import { actions } from "app/containers/Features/containers/TeamSettings/container/Notification/redux/slice";

interface NotificationTableProps {
  category: string;
}

const GRID_TEMPLATE_COLUMNS = "repeat(3, 1fr)";

const NotificationTable: React.FC<NotificationTableProps> = ({ category }) => {
  const dispatch = useDispatch();
  const data = useSelector(selectNotificationSettings);
  const isLoading = useSelector(selectIsLoading);

  const handleToggle = useCallback(
    (id: string, field: NotificationMethodEnum) => {
      dispatch(actions.toggleNotification({ id, field }));
    },
    [dispatch],
  );

  const categoryRows = useMemo(
    () => (data || []).filter((row) => row.category === category),
    [data, category],
  );

  return (
    <div className="w-full bg-white">
      <CommonGridTable
        headers={headers}
        gridTemplateColumns={GRID_TEMPLATE_COLUMNS}
        className="w-full"
        isLoading={isLoading}
        padding="!px-0"
        headerClassName="bg-gray-200 !border-x !border-b !border-t-0 !border-gray-100 !rounded-none !h-[42px]!min-h-[42px]"
        headerTitleClassName="w-full h-full flex items-center px-6 text-[14px] font-medium text-secondary"
      >
        {categoryRows.map((row) => (
          <NotificationRow
            key={row._id}
            row={row}
            gridTemplateColumns={GRID_TEMPLATE_COLUMNS}
            onToggle={handleToggle}
          />
        ))}
      </CommonGridTable>
    </div>
  );
};

export default React.memo(NotificationTable);
